var alignment_default = {
  "alignLeft": "xO-w4",
  "textWrapNowrap": "w4qx0",
  "alignRight": "sgbFV",
  "alignCenter": "_8FlMH",
  "sizeFullWidth": "DuGOT",
  "renderedInTable": "If9Tv",
  "sizeOriginal": "da84I",
  "sizeContent": "P8lQY",
  "sizeSmall": "AcUAM",
  "sizeSmallCenter": "a5XOF",
  "flex": "tFX-K",
  "LEFT": "_4RiJy",
  "CENTER": "_9iRmY",
  "RIGHT": "-r5k8",
  "AUTO": "_20N9R",
  "JUSTIFY": "e0fys"
};
export {
  alignment_default as default
};
//# sourceMappingURL=alignment-scss.js.map
